import { render, staticRenderFns } from "./paged_list.vue?vue&type=template&id=1fa93e72&"
import script from "./paged_list.vue?vue&type=script&lang=js&"
export * from "./paged_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports